import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

/**
 * Empty State Tab Component
 * 
 * Displays an empty state for tabs that are not supported by the current client.
 * Shows a message indicating that this feature is not available for the current organization.
 */
const EmptyStateTab = ({ tabLabel, searchQuery }) => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="text-center max-w-md">
        <Icon 
          icon="material-symbols:block" 
          className="text-8xl text-font-secondary opacity-30 mx-auto mb-6" 
        />
        <h3 className="text-xl font-semibold text-font-primary mb-2">
          {tabLabel} Not Available
        </h3>
        <p className="text-font-secondary mb-4">
          This feature is not available for your current organization.
        </p>
        {searchQuery && (
          <p className="text-sm text-font-secondary">
            No {tabLabel.toLowerCase()} results found for "{searchQuery}"
          </p>
        )}
      </div>
    </div>
  );
};

export default EmptyStateTab;
